var map = {
	"./1960_1961.jpg": 121,
	"./1961_1962.jpg": 122,
	"./1962_1963.jpg": 123,
	"./1963_1964.jpg": 124,
	"./1964_1965.jpg": 125,
	"./1965_1966.jpg": 126,
	"./1966_1967.jpg": 127,
	"./1967_1968.jpg": 128,
	"./1968_1969.jpg": 129,
	"./1969_1970.jpg": 130,
	"./1970_1971.jpg": 131,
	"./1971_1972.jpg": 132,
	"./1972_1973.jpg": 133,
	"./1973_1974.jpg": 134,
	"./1974_1975.jpg": 135,
	"./1975_1976.jpg": 136,
	"./1976_1977.jpg": 137,
	"./1977_1978.jpg": 138,
	"./1978_1979.jpg": 139,
	"./1979_1980.jpg": 140,
	"./1980_1981.jpg": 141,
	"./1981_1982.jpg": 142,
	"./1982_1983.jpg": 143,
	"./1983_1984.jpg": 144,
	"./1984_1985.jpg": 145,
	"./1985_1986.jpg": 146,
	"./1986_1987.jpg": 147,
	"./1987_1988.jpg": 148,
	"./1988_1989.jpg": 149,
	"./1989_1990.jpg": 150,
	"./1990_1991.jpg": 151,
	"./1991_1992.jpg": 152,
	"./1992_1993.jpg": 153,
	"./1993_1994.jpg": 154,
	"./1994_1995.jpg": 155,
	"./1995_1996.jpg": 156,
	"./1996_1997.jpg": 157,
	"./1997_1998.jpg": 158,
	"./1998_1999.jpg": 159,
	"./1999_2000.jpg": 160,
	"./2000_2001.jpg": 161,
	"./2001_2002.jpg": 162,
	"./2002_2003.jpg": 163,
	"./2003_2004.jpg": 164,
	"./2004_2005.jpg": 165,
	"./2005_2006.jpg": 166,
	"./2006_2007.jpg": 167,
	"./2007_2008.jpg": 168,
	"./2008_2009.jpg": 169,
	"./2009_2010.jpg": 170,
	"./2010_2011.jpg": 171,
	"./2011_2012.jpg": 172,
	"./2012_2013.jpg": 173,
	"./2013_2014.jpg": 174,
	"./2014_2015.jpg": 175,
	"./2015_2016.jpg": 176,
	"./2016_2017.jpg": 177,
	"./2017_2018.jpg": 178,
	"./2018_2019nnnn.png": 179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 120;